import {domain} from '../common.js';
import clientUUID from '@/client.js';

export const loader = (lang, query) => fetch(`${domain}/${lang}/gaz/oferte`, {
  method: 'post',
  body: JSON.stringify(query),
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Client-UUID': clientUUID
  }
});
